@use '../../scss/global' as *;
@use '../../scss/components' as *;
@use 'themes';
@use 'dropdown-menu';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  // FLUID Navigation: Base Styles
  @include navigation-base;

  .fluid-tree-menu {
    display: block;

    // ==== Sidebar Tree Menu Offset

    &.sidebar-menu {
      margin-left: calc(var(--sidebar-padding-left) * -1);
      margin-right: calc(var(--sidebar-padding-right) * -1);
    }

    // ==== Menu Item Text Overflow (Global)

    &.text-overflow-clip {
      .fluid-nav-label {
        text-overflow: clip;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    &.text-overflow-ellipsis {
      .fluid-nav-label {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    // ==== List Container

    .fluid-nav-list {}

    // ==== List Item Container

    .tree-menu-nav-item {
      display: block;
    }

    // ==== Submenu Container

    .submenu-container {
      display: grid;
      grid-template-rows: 0fr;
      overflow: hidden;

      @include transition(
        $properties: 'grid-template-rows',
        $duration: short
      );

      &.submenu-expanded {
        grid-template-rows: 1fr;
      }
    }

    // ==== Submenu

    .tree-menu-submenu {
      max-width: 100%;
      overflow: hidden;
      min-height: 0;

      @include transition(
        $properties: 'visibility',
        $delay: short,
      );

      &.submenu-open {
        visibility: visible;
        transition-delay: 0ms;
      }

      &.submenu-closed {
        visibility: hidden;

        // Hide nested open submenus
        .submenu-open {
          visibility: hidden;
        }
      }
    }

    // ==== Tree Node (Link, Submenu Button, Title, & Divider)

    .tree-node {
      font-size: var(--node-font-size);
      padding-top: var(--node-padding-top);
      padding-bottom: var(--node-padding-bottom);
      padding-left: calc(var(--node-padding-left) * (var(--submenu-depth, 0) + 1));
      padding-right: var(--node-padding-right);
    }

    // ==== Section Heading

    .tree-menu-title {

      .fluid-nav-label {
        display: block;
        font-weight: var(--title-font-weight, $font-weight-regular);
        line-height: var(--title-line-height, 1.25);
        color: var(--title-color);
        font-size: max(
          calc(var(--title-font-size) - (var(--submenu-depth, 0) * 0.1em)),
          calc(var(--menu-item-font-size) + 1px)
        );
      }
    }

    // ==== Divider

    .tree-menu-divider {
      hr {
        height: var(--divider-weight, 2px);
        background-color: var(--divider-background-color);
      }
    }

    // ==== Shared Button Styles

    .tree-menu-link,
    .tree-menu-submenu-button {
      width: 100%;
      display: flex;
      align-items: center;
      column-gap: 0.75em;
      text-align: left;
      font-weight: var(--menu-item-font-weight, $font-weight-regular);
      line-height: var(--menu-item-line-height, inherit);
      color: var(--menu-item-color);
      background-color: var(--menu-item-background-color, transparent);
      outline: 0;

      @include transition(
        $properties: 'background-color, color, font-size, font-weight',
        $duration: short
      );

      // == Disabled

      &.button-disabled {
        cursor: not-allowed;
        outline: 0;

        .fluid-nav-label {
          opacity: 0.5;
        }

        .fluid-nav-submenu-icon {
          opacity: 0.4;
        }
      }

      // == Button Label

      .fluid-nav-label {
        font-size: var(--menu-item-font-size);
      }
    }

    // ==== Link Button

    .tree-menu-link {}

    // ==== Submenu Button

    .tree-menu-submenu-button {

      &.submenu-active {
        font-weight: $font-weight-bold;
      }

      &.submenu-button-inactive {
        background-color: transparent;
        pointer-events: none;
      }

      .fluid-nav-submenu-icon {
        color: inherit; // Sets FLUID Icon "fill" color
      }
    }

    // ==== Button Label

    .fluid-nav-label {

      &:not(:last-child) {
        &:not(:has(+ .fluid-nav-badge)) {
          margin-right: auto;
        }
      }

      & + .fluid-nav-badge {
        margin-right: auto;
      }

      // == Text Overflow (Overrides "Global" Styles)

      &.text-overflow-wrap {
        white-space: normal;
        overflow: visible;
      }

      &.text-overflow-clip {
        text-overflow: clip;
        white-space: nowrap;
        overflow: hidden;
      }

      &.text-overflow-ellipsis {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    // ==== Icons

    .fluid-nav-icon {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      color: inherit; // Sets FLUID Icon "fill" color
    }

    // ==== Badge

    .fluid-nav-badge {
      flex: 0 0 auto;
    }
  }
}
